import React from 'react'
import Header from '../Components/Header/Header'
import Footer from '../Components/Footer/Footer'

function Home() {
    return (
        <div>
            <Header />
            <Footer />
        </div>
    )
}

export default Home
